export interface User {
  username: string;
  displayName: string;
  token: string;
  image?: string;
}

export interface IUserLoginData {
  access_token: string;
  refresh_token: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  phoneNumber: string;
  role: any;
  isEmailVerified: boolean;
  sellingPermission: boolean;
  isSuspended: boolean;
  isActive: boolean;
  isProfileCompleted: boolean;
  createdAt: any;
}

export interface UserProfile {
  access_token: string;
  refresh_token: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  phoneNumber: string;
  role: null;
  isEmailVerified: true;
  sellingPermission: false;
  isSuspended: false;
  isActive: false;
  isProfileCompleted: true;
  userStoreId: null;
  roleName: string;
  addProducts: boolean;
  addUsers: boolean;
  viewOrders: boolean;
  tickets: boolean;
  shipping: boolean;
  settings: boolean;
  createdAt: Date;
  fileName: string;
  businessName: string;
  businessAddress: string;
  businessStructure: string;
  firmSize: string;
  annualTurnover: string;
  experienceNigeriaMarket: string;
  renewableEnergy: string;
  relevanceOfCVs: string;
  noOfInstallationsDone: string;
  levelOfWarrantySolar: string;
  localPresences: string;
  experienceSolarSystem: string;
  establishedYears: string;
  percentTotalAnnualTurnOver: string;
  totalVendorPercentage: string;
}

export interface UserFormValues {
  email: string;
  password: string;
  // displayName?: string;
  // username?: string;
}

export class VendorRegistrationForm {
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  address: string = "";
  state: string = "";
  city: string = "";
  phoneNumber: string = "";
  saFcurrentAccount: string = "";
  businessName: string = "";
  categoryOfProduct: string[] = [];
  firmSize: string = "";
  establishedYears: string = "";
  annualTurnover: string = "";
  percentTotalAnnualTurnOver: string = "";
  businessStructure: string = "";
  relevanceOfCVs: string = "";
  localPresences: string = "";
  noOfInstallationsDone: string = "";
  experienceNigeriaMarket: string = "";
  experienceSolarSystem: string = "";
  levelOfWarrantySolar: string = "";
  renewableEnergy: string = "";
}

export interface IVendorRegistrationForm {
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  state: string;
  city: string;
  phoneNumber: string;
  saFcurrentAccount: string;
  confirmPassword: string;
  categoryOfProduct: string;
}
export class VendorUpdateForm {
  headerImageUrl: string | null = "";
  logoImageUrl: string | null = "";
  storeAddress: string | null = "";
  storeInformation: string | null = "";
  state: string | null = "";
  city: string | null = "";
  storeName: string | null = "";
  password: string | null = "";
}
export class VendorLoginForm {
  email: string = "";
  password: string = "";
}
export class PasswordChangeForm {
  email: string = "";
  confirmPassword: string = "";
  newPassword: string = "";
}
export class PasswordOtpData {
  phoneNumber: string = "";
  otp: string = "";
}

export class VendorScoreForm {
  firmSize: string = "";
  establishedYears: string = "";
  annualTurnover: string = "";
  percentTotalAnnualTurnOver: string = "";
  businessStructure: string = "";
  relevanceOfCVs: string = "";
  localPresences: string = "";
  noOfInstallationsDone: string = "";
  experienceNigeriaMarket: string = "";
  experienceSolarSystem: string = "";
  levelOfWarrantySolar: string = "";
  renewableEnergy: string = "";
}
export interface IVendorScoreForm {
  firmSize: string;
  establishedYears: string;
  annualTurnover: string;
  percentTotalAnnualTurnOver: string;
  businessStructure: string;
  relevanceOfCVs: string;
  localPresences: string;
  noOfInstallationsDone: string;
  experienceNigeriaMarket: string;
  experienceSolarSystem: string;
  levelOfWarrantySolar: string;
  renewableEnergy: string;
}
export class VendorsResponse {
  data: any | null;
  responseCode: string = "";
  responseMessage: string = "";
  isSuccessful: boolean = false;
}
export interface IVendorsAccountResponse {
  data: {
    message: string;
    getAccounts: AccountInfo;
  };
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}
export interface AccountInfo {
  brancH_NAME: string;
  brancH_CODE: string;
  accounT_NO: string;
  acC_TYPE: string;
  currency: string;
  currencY_CODE: string;
  gL_CODE: number;
  ciF_SUB_NO: number;
  sL_NO: number;
  bvn: string;
  acC_NAME: string;
  status: string;
  ciF_STATUS: string;
  phonE_NUMBER: string;
  email: string;
  haS_PND: string;
  cusT_TYPE: string;
  datE_OPENED: string;
  firsT_NAME: string;
  lasT_NAME: string;
  aval_Balance: number;
  rM_NAME: string;
  daO_CODE: string;
  accounT_CLASS:string;
}
export class ProductCategory {
  categoryId: string = "";
  category: string = "";
}
export class States {
  regioN_CODE: string = "";
  state: string = "";
}
export class AccountInformation {
  vendorId: string = "";
  role: number = 0;
  state: string | null = "";
  city: string | null = "";
  headerImageUrl: string | null = "";
  storeAddress: string | null = "";
  businessName: string | null = "";
  storeName: string | null = "";
  storeLogoUrl: string | null = "";
  firstName: string | null = "";
  lastName: string | null = "";
  email: string | null = "";
  gender: string | null = "";
  address: string | null = "";
  phoneNumber: string | null = "";
  password: string | null = "";
  isEmailVerified: boolean = false;
  sellingPermission: boolean = false;
  status: string | null = "";
  isProfileCompleted: boolean = false;
  isActive: string | null = "";
  isSuspended: boolean = false;
  rating: string | null = "";
  slug: string | null = "";
  storeUrl: string | null = "";
  storeLGA: string | null = "";
  storeState: string | null = "";
  bankAccountName: string | null = "";
  bankAccountNumber: string | null = "";
  storeInformation: string | null = "";
  appNotificationFlag : boolean = false;
  mailNotificationFlag : boolean = false;
}
export enum EstablishedYears {
  OverFiveYears = "OverFiveYears",
  OverTwoYears = "OverTwoYears",
  LessThanTwoYears = "LessThanTwoYears",
}
export enum FirmSize {
  OverTwentyFive = "OverTwentyFive",
  TenToTwenty = "TenToTwenty",
  LessThanTen = "LessThanTen",
}
export enum AnnualTurnover {
  OverFiveHundredMetre = "OverFiveHundredMetre",
  OneHundredAndOneToFiveHundredMetre = "OneHundredAndOneToFiveHundredMetre",
  LessThanHundredMetre = "LessThanHundredMetre",
}
export enum PercentTotalAnnualTurnOver {
  OverEightyPercent = "OverEightyPercent",
  FortyToEightyPercent = "FortyToEightyPercent",
  LessThanFortyPercent = "LessThanFortyPercent",
}
export enum BusinessStructure {
  Excellence = "Excellence",
  Average = "Average",
  Poor = "Poor",
}
export enum RelevanceOfCVs {
  Excellence = "Excellence",
  Average = "Average",
  Poor = "Poor",
}
export enum LocalPresences {
  High = "High",
  Average = "Average",
  Poor = "Poor",
}
export enum NoOfInstallationsDone {
  OverFiveHundred = "OverFiveHundred",
  HundredToFourHundredNinetyNine = "HundredToFourHundredNinetyNine",
  LessThanHundred = "LessThanHundred",
}
export enum ExperienceNigeriaMarket {
  OverSix = "OverSix",
  ThreeToFive = "ThreeToFive",
  LessThanTwo = "LessThanTwo",
}
export enum ExperienceSolarSystem {
  OverFive = "OverFive",
  ThreeToFive = "ThreeToFive",
  LessThanTwo = "LessThanTwo",
}
export enum RenewableEnergy {
  PVPanels = "PVPanels",
  Inverters = "Inverters",
  Batteries = "Batteries",
}
export enum WarantyOfSolarSolution {
  OverFive = "OverFive",
  ThreeToFive = "ThreeToFive",
  LessThanTwo = "LessThanTwo",
}

export interface DashboardInfo {
  monthlyTransaction: {
    totalTransaction: number;
    jan: number;
    mar: number;
    may: number;
    jul: number;
    sep: number;
    nov: number;
  };
  vendorProducts: {
    allProducts: number;
    liveProducts: number;
    soldOut: number;
    rejected: number;
  };
  vendorOrder: {
    totalOrder: number;
    cancelled: number;
    returned: number;
  };
}

export interface IStatModel {
  name: string;
  uv: number;
}

export interface IGraphModel {
  name: string;
  amount: number;
}

export interface IPieChartModel {
  name: string;
  orders: number;
}

export interface ITransactionModel {
  customerName: string;
  amount: number;
  transactionReference: string;
  paymentMethod: string;
  paymentStatus: string;
  paymentDate: string;
}
export interface INotificationModel {
  notificationId: string;
  title: string;
  message: string;
  eventId: string;
  adminRoleName: string;
}

export interface INotificationResponse {
  data: INotificationModel[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export interface IUserRoleModel {
  vendorRoleId: string;
  roleName: string;
  description: string;
  status: string;
}
export interface IUserRole {
  storeUserId: string;
  email: string;
  phoneNumber: string;
  roleName: string;
  status: string;
  dateCreated: string;
  name: string;
  lastName : string;
  storeUserPriviledges: {
    createdAt: Date;
    updatedAt: Date;
    storeUserPrivilegeId: string;
    storeUserId: string;
    vendorId: string;
    addProducts: boolean;
    addUsers: boolean;
    viewOrders: boolean;
    tickets: boolean;
    shipping: boolean;
    settings: boolean;
  };
}
export interface IUserRoleResponse {
  data: IUserRole;
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export class UpdateUserRole {
  storeUserId: string = "";
  status: string = "";
}
export interface IUserRolesResponse {
  data: IUserRoleModel[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export interface IUserRoleForm {
  name: string;
  email: string;
  password: string;
  phoneNumber: string;
  vendorRoleId: string;
  vendorId: string;
  addProducts: boolean;
  addUsers: boolean;
  viewOrders: boolean;
  tickets: boolean;
  shipping: boolean;
  settings: boolean;
}

export class UserRoleForm {
  name: string = "";
  email: string = "";
  password: string = "";
  phoneNumber: string = "";
  vendorRoleId: string = "";
  vendorId: string = "";
  addProducts: boolean = false;
  addUsers: boolean = false;
  viewOrders: boolean = false;
  tickets: boolean = false;
  shipping: boolean = false;
  settings: boolean = false;
}

export interface ILoggedInUser {
  access_token: string;
  refresh_token: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  phoneNumber: string;
  role: null;
  isEmailVerified: true;
  sellingPermission: false;
  isSuspended: false;
  isActive: false;
  isProfileCompleted: true;
  userStoreId: null;
  roleName: string;
  addProducts: boolean;
  addUsers: boolean;
  viewOrders: boolean;
  tickets: boolean;
  shipping: boolean;
  settings: boolean;
  createdAt: Date;
}

export interface IVendorUsers {
  storeUserId: string;
  email: string;
  phoneNumber: string;
  roleName: string;
  status: string;
  dateCreated: string;
  name: string;
  lastName : string;
  storeUserPriviledges: {
    storeUserPrivilegeId: "38c7f45e-4b38-4218-b5d5-6a780d3766ab";
    storeUserId: string;
    vendorId: "9440f022-00f7-4c67-a149-3c55257426b6";
    addProducts: true;
    addUsers: false;
    viewOrders: true;
    tickets: true;
    shipping: true;
    settings: false;
    createdAt: "2023-10-19T13:36:49.3367459";
    updatedAt: null;
  };
}

export interface IVendorUsersResponse {
  data: IVendorUsers[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export enum UserPermissions {
  addProducts = "addProducts",
  addUsers = "addUsers",
  viewOrders = "viewOrders",
  tickets = "tickets",
  shipping = "shipping",
  settings = "settings",
}
